<template>
  <div class="row justify-content-center" style="">
    <div class="col-12 col-md-10 col-lg-8 col-xl-8">
      <div class="tit text-center">
        <h2>Outras informações</h2>
      </div>
      <form @submit.prevent="submit">
        <div class="form-row">
          <div class="form-group col-12 col-md-6">
            <label for="rendaMensal">Renda mensal aprox. (R$) *</label>
            <input tabindex="1" v-model="rendaMensal" id="rendaMensal" class="form-control form-control-lg" type="text" required placeholder="Renda mensal" v-mask="'money'" @keyup="validaRenda"/>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="patriAprox">Patrimônio aprox. (R$) *</label>
            <input tabindex="2" v-model="patrimonio" id="patriAprox" class="form-control form-control-lg" type="text" required placeholder="Patrimônio" v-mask="'money'"/>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-md-12 text-center" @click="showModal = true">
						<p style="color: #41D3BD" class="link">Você é uma Pessoa Politicamente Exposta?</p>
          </div>

					<modal v-if="showModal" class="modal-invited" @close="closeModal()"> 
						<div slot="header">
							<h3 >
								O que é ser um PPE (Pessoa Politicamente Exposta - PPE)?
							</h3>
						</div>
						<div slot="body">
							<p>
								Consideram-se pessoas politicamente expostas os
								agentes públicos que desempenham ou tenham
								desempenhado, nos cinco anos anteriores, no
								Brasil ou em países, territórios e dependências
								estrangeiros, cargos, empregos ou funções
								públicas relevantes, assim como seus
								representantes, familiares e outras pessoas de
								seu relacionamento próximo, conforme definido
								pela ENCLA (Estratégia Nacional de Combate à
								Corrupção e à Lavagem de Dinheiro).
							</p>

							<p>Fonte: <a class="link" href="https://pt.wikipedia.org/wiki/Pessoas_politicamente_expostas" target="_blank">Pessoas politicamente expostas</a></p>
						</div>
						
					</modal>

          <div class="form-group col-12 col-md-12 align-self-center text-center" style="padding-bottom: 30px;">
            <div class="form-check form-check-inline">
              <div class="checkContainer">
                <input tabindex="3" class="form-check-input" type="radio" name="tipo_conta" v-model="pessoaPoliticamenteExposta" id="cc" :value="true" required>
                <span class="checkmark"></span>
                <label class="form-check-label" for="cc"><strong>Sim</strong>, declaro ser PPE.</label>
              </div>
            </div>
            <div class="form-check form-check-inline">
              <div class="checkContainer">
                <input tabindex="4" class="form-check-input" type="radio" name="tipo_conta" v-model="pessoaPoliticamenteExposta" id="cp" :value="false" required>
                <span class="checkmark"></span>
                <label class="form-check-label" for="cp"><strong>Não</strong>, declaro não ser PPE.</label>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center fixedOptions">
           <button class="btn btn-lg btn-primary">Próximo <img src="/static/assets/images/angle-right.svg"></button>
        </div>
      </form>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "../../assets/styles/iouu/mixins";
@import "../../assets/styles/landing-page/vars";

	.link {
		cursor:pointer;
    color:$tealish;
	}

  @include xs {
    .steps {
      .form-check {
        padding-left: 0;
      }
    }

    .form-check-inline + .form-check-inline {
      margin-left: 32px;
      margin-top: 10px;
		}
  }
</style>

<script>
  import Masker from '@/utils/masker'
	import Modal from '@/components/Modal'

  export default {
		components: { Modal },

    data() {
			const investor = this.investor
      return {
				showModal: false,
				rendaMensal: investor.RendaMensal ? investor.RendaMensal.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null,
				patrimonio: investor.Patrimonio ? investor.Patrimonio.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null,
        pessoaPoliticamenteExposta: investor.PessoaPoliticamenteExposta,
      }
    },
    props: {
      investor: {type: Object, required: true}
    },
    methods: {
      validaRenda(e){
        if(Masker.formatReal(e.target.value)<=0){
          this.rendaMensal = ''
        }
      },
      submit() {
        this.$emit('submit', {
          RendaMensal: Masker.formatReal(this.rendaMensal),
          Patrimonio: Masker.formatReal(this.patrimonio),
          PessoaPoliticamenteExposta: this.pessoaPoliticamenteExposta
        })
			},
			closeModal() {
				this.showModal = false
			}
			
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationInvestor/PassoOutrasInformacoes.vue